module.exports = __webpack_public_path__ + "static/media/109617red.e83a181e.svg";